<template>
  <Module :modifiers="['object-metadata']" :title="heading">
    <div class="m-object-metadata__columns">
      <div :class="metadataClasses">
        <RecordMetadataField
          v-for="(value, key) in metadataFields"
          :id="key"
          :key="'_' + key"
          :ref="'metadata-field-' + key"
          :label="key"
          label-suffix=":"
          :base-locale-key="'object_metadata'"
          :data-testid="'metadata-' + key"
          :values="value"
          :value-delimiter="'block'"
        />
      </div>
      <RelatedResources
        :id="humanMadeObject.id"
        ref="links"
        :exclude-external-hosts="['youtu', 'getty.edu/education']"
        :links="humanMadeObject?.relatedLinks"
        :classes="['m-object-metadata__right-column']"
      />
    </div>
  </Module>
</template>

<script>
import {
  Module,
  RecordMetadataField,
  useLocalization
} from "@thegetty-private/getty-ui";
import * as configHelper from "@/helpers/configHelper";
import RelatedResources from "@/components/molecules/relatedResources/index.vue";

export default {
  name: "HumanMadeObjectMetadata",
  components: {
    Module,
    RecordMetadataField,
    RelatedResources
  },
  provide() {
    return {
      /**
       * Turn off Markdown in DelimitedFieldValues
       */
      useMarkdownInDelimitedValues: true
    };
  },
  props: {
    /**
     * The HumanMadeObject data from the Store
     */
    humanMadeObject: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /**
       * the base class name
       */
      baseClass: "m-object-metadata",
      /**
       * the heading
       */
      heading: this.translatePart("object_page.object_details"),
      /**
       * The maximum # of fragments to display
       */
      maxFragmentsToDisplay: configHelper.getMaxFragmentsToDisplay()
    };
  },
  computed: {
    /**
     * The classes to apply to the metadata section
     *
     * @returns {array}
     */
    metadataClasses() {
      let classes = [`${this.baseClass}__left-column`];

      if (this.truncateFragmentLinks) {
        classes.push(`${this.baseClass}__truncate-fragments`);
        return classes;
      }

      return classes;
    },
    /**
     * Gets the metadata fields
     *
     * @returns {object} an object with key/value pairs for the metadata
     */
    metadataFields() {
      return this.humanMadeObject?.metadata;
    },
    /**
     * Whether or not the metadata fragment list has been truncated
     * and needs additional styling (another class)
     *
     * @returns {boolean}
     */
    truncateFragmentLinks() {
      let numLinks = this.humanMadeObject?.structure?.parts?.length || 0;

      return numLinks > this.maxFragmentsToDisplay ? true : false;
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
